import { windowReady } from 'html-ready';
import { derived, readable, writable } from 'svelte/store';
import { saveEnergy } from './storedSettings';
export const screenSaver = writable(false);
export const darkenClock = writable(false);
export const colorSelector = writable(undefined);
// prevent style change until the lock is released
export const styleChangeLock = writable(false);
// the source of the background image of the clock
export const mainBgSource = writable(null);
// check online status
export const onlineStatus = readable(true, (set) => {
    window.addEventListener('online', setOnlineStatus);
    window.addEventListener('offline', setOfflineStatus);
    function setOnlineStatus() {
        set(true);
    }
    function setOfflineStatus() {
        set(false);
    }
    return () => {
        window.removeEventListener('online', setOnlineStatus);
        window.removeEventListener('online', setOfflineStatus);
    };
});
let changeSizeTimeout;
export const screenSize = readable(99999999, (set) => {
    window.addEventListener('resize', setScreenSize);
    function setScreenSize(e) {
        clearTimeout(changeSizeTimeout);
        changeSizeTimeout = setTimeout(() => {
            set(window.innerWidth);
        }, 250);
    }
    return () => clearTimeout(changeSizeTimeout);
});
export const mobileStatus = derived(screenSize, function (value) {
    return (value < 768);
});
// tips
export const tips = writable(null);
export const alarmIsRinging = writable(false);
export const timerIsRinging = writable(false);
export const pinnedDBisReady = writable(false);
export const clockIsVisible = readable(true, (set) => {
    if (!('IntersectionObserver' in window)) {
        set(true);
        return () => 0;
    }
    windowReady.then(() => {
        const el = document.querySelector('#big-clock');
        const obs = new IntersectionObserver((e) => {
            set(e[0].intersectionRatio > 0);
        }, { 'root': null, 'threshold': 0 });
        obs.observe(el);
        return () => obs.unobserve(el);
    });
});
// check Window focus
export const windowFocus = readable(true, (set) => {
    window.addEventListener('focus', setFocusStatus);
    window.addEventListener('blur', setBlurStatus);
    function setFocusStatus() {
        set(true);
        console.log('window has focus');
    }
    function setBlurStatus() {
        set(false);
        console.log('window has LOST focus');
    }
    return () => {
        window.removeEventListener('online', setFocusStatus);
        window.removeEventListener('online', setBlurStatus);
    };
});
export const reduceAnimations = derived([windowFocus, saveEnergy], ([$w, $s]) => {
    return !$w && $s;
});
export const modalContent = writable(null);
export const bgImageBright = writable('none');
